/** @format */

import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import { useStoreState, useStoreActions } from 'easy-peasy';

import ResetState from './ResetState';

function Header(props) {
	const [t] = useTranslation('translation');
	const service = useStoreActions((actions) => actions.header);
	const data = useStoreState((state) => state.header);
	const userService = useStoreActions((actions) => actions.user);
	const setUserLanguage = useStoreActions((action) => action.user.setLanguage);

	useEffect(() => {
		userService.refreshAppLanguage();
	}, [userService]);

	return (
		<nav>
			<div>
				<div>
					<button className='toggler' onClick={() => service.toggleHamburger()}></button>
				</div>
				<div></div>
				<ResetState>
					<h1>
						<Link to='/'>{t('booking')}</Link>
					</h1>
				</ResetState>
				<div><div> </div></div>
				<div>
					<ul className='user'>
						<li onClick={(e) => setUserLanguage('en')}>English</li>
						<li onClick={(e) => setUserLanguage('nb')}>Norsk</li>
					</ul>
				</div>
			</div>
			{data.HamburgerExpanded && (
				<ul onClick={() => service.toggleHamburger()}>
					<li>
						<Link to='/'>{t('home')}</Link>
					</li>
					<li>
						<Link to='/Terms'>{t('terms')}</Link>
					</li>
					<li>
						<a
							href='https://www.norled.no/hurtigbat-og-ferje/takster-og-prisinformasjon/'
							target='_blank'
							rel='noopener noreferrer'
						>
							{t('timetables')}
						</a>
					</li>
				</ul>
			)}
		</nav>
	);
}

export default Header;
